import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {isSameYearAndMonth} from '@shared/dateUtils';
import {getYYYYMMFormat} from '@di-shared/api/di/utils';
import {SelectMonthBottomSheetData} from '@di-shared/features/history/driving-info/SelectMonthBottomSheet/index';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';

export default function () {
  const {months, selectedDate} = (window as any).data as SelectMonthBottomSheetData;
  const {t} = useInferableTranslation();
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();

  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T10025')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose()}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          />
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <div className="select_box">
            {months.map((month) => (
              <React.Fragment key={getYYYYMMFormat(month)}>
                <input
                  className="input"
                  type="radio"
                  name="month_select"
                  id={getYYYYMMFormat(month)}
                  checked={selectedDate ? isSameYearAndMonth(selectedDate, month) : undefined}
                  onChange={() => (window as any).bottomSheetClose(month)}
                />
                <label
                  className="label"
                  htmlFor={getYYYYMMFormat(month)}
                >
                  <span className="text">{CldrDatetimeFormatter.format(month, 'yMMM')}</span>
                </label>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
